/**
 * Constantes utilizadas para el flujo de autenticación OAuth2 con Microsoft
 *
 * @remarks
 * - Define query params esperados en el callback
 * - URLs de redirección para el flujo OAuth2
 * - Mensajes y tiempos de espera para la UX
 *
 * @example
 * ```typescript
 * import { OAUTH_CONSTANTS } from './constants/oauth.constants';
 *
 * // En componente de callback
 * const token = this.route.snapshot.queryParamMap.get(OAUTH_CONSTANTS.QUERY_PARAM_TOKEN);
 * ```
 */
export const OAUTH_CONSTANTS = {
  // Query Params
  /** Nombre del parámetro que contiene el token JWT en el callback */
  QUERY_PARAM_TOKEN: 'code',
  /** Nombre del parámetro que contiene el código de error del backend */
  QUERY_PARAM_ERROR: 'error',
  /** Nombre del parámetro con la descripción detallada del error */
  QUERY_PARAM_ERROR_DESCRIPTION: 'error_description',

  // URLs
  /** URL base para el callback de OAuth2 */
  OAUTH_CALLBACK_URL: '/auth',
  /** Endpoint del backend que inicia el flujo OAuth2 con Microsoft */
  OAUTH_BACKEND_LOGIN_URL: '/api/timepro/v1/auth/oauth2/login',
  /** Endpoint del backend que cierra la sesión OAuth2 */
  OAUTH_BACKEND_LOGOUT_URL: '/api/timepro/v1/auth/oauth2/logout',
  /** Ruta del componente que redirige al backend OAuth2 */
  OAUTH_REDIRECT_ROUTE: '/auth/oauth-redirect',
  /** Ruta del componente que cierra la sesión OAuth2 */
  OAUTH_LOGOUT_ROUTE: '/auth/oauth-logout',

  // Mensajes
  /** Mensaje mostrado mientras se redirige a Microsoft */
  LOADING_MESSAGE: 'Autenticando con Microsoft...',
  /** Mensaje mostrado mientras se cierra la sesión */
  LOGOUT_MESSAGE: 'Cerrando sesión...',

  // Tiempos (en milisegundos)
  /** Tiempo de espera antes de redirigir automáticamente */
  REDIRECT_DELAY: 2000,
} as const;
